module.exports = __webpack_public_path__ + "static/media/video_empty.fb8788c9.svg";